import Bubble from "./Bubble";
import { Loader, Application, utils } from 'pixi.js';
import BubblesBlob from "./BubblesBlob";
import { bubbleOptions } from "./Options";
import {debounce} from "../../../utils";

class RaisingHealthScene {
    constructor(el) {
        this.el = el;
        this.bubbleOptions = bubbleOptions;
        this.bubbles = [];
        this.windowWidth = window.innerWidth;
        this.currentBreakpointMobile = this.getIsMobile();
        this.setSizes();
        this.initScene();
        this.loadImages();
        this.initEvents();
    }

    getIsMobile() {
        return window.innerWidth < 768;
    }

    loadImages() {
        this.loader = new Loader();
        this.bubbleOptions.forEach((option, index) => {
            this.loader.add(`bubble_texture_${index}`, option.textureURL);
        });
        this.loader.add('blob', `${window.assets_url}/images/raising-health/blob.png`);
        this.loader.add('bubbleShader', `${window.assets_url}/images/raising-health/bubble.frag`);
        this.loader.load((loader, resources) => {
            this.resources = resources;
            this.createBlob();
            this.createBubbles();
        });
    }

    getSceneSize() {
        return { width: this.elWidth, height: this.elHeight, scale: this.scale };
    }

    createBlob() {
        this.scale = this.elWidth / this.resources.blob.texture.orig.width;

        this.blob = new BubblesBlob(this.getSceneSize.bind(this), {
            texture: this.resources.blob.texture,
            deformX: 0.003,
            deformY: 0.003,
            deformDelta: 2000,
            fragmentShader: this.resources.bubbleShader.data,
        })
        this.blob.addToStage(this.app.stage);
    }

    createBubbles() {
        this.bubbleOptions.forEach((option, index) => {
            let bubbleTexture = this.resources[`bubble_texture_${index}`].texture;
            let bubble = new Bubble(this.getSceneSize.bind(this), {
                id: index,
                fragmentShader: this.resources.bubbleShader.data,
                texture: bubbleTexture,
                x: option.x,
                y: option.y,
                speed: option.speed,
                deformX: option.deformX,
                deformY: option.deformY,
                deformDelta: option.deformDelta,
                xPercent: option.xPercent,
                yPercent: option.yPercent,
            });
            bubble.addToStage(this.app.stage);
            this.bubbles.push(bubble);
        });
    }

    update(delta) {
        this.bubbles.forEach(bubble => bubble.update(delta));

        if(this.blob) {
            this.blob.update(delta);
        }
    }

    setSizes() {
        this.elWidth = this.el.offsetWidth;
        this.elHeight = this.el.offsetHeight;
    }

    initScene() {
        utils.skipHello();
        this.app = new Application({
            width: this.elWidth,
            height: this.elHeight,
            backgroundAlpha: 0,
            resolution: 2,
            autoResize: true,
            antialias: true,
        });
        this.el.appendChild(this.app.view);

        this.app.ticker.add(delta => this.update(delta));

        if(this.currentBreakpointMobile) {
            this.app.ticker.stop();
        }
    }

    resizeHandler() {
        const newBreakpointMobile = this.getIsMobile();
        if(newBreakpointMobile !== this.currentBreakpointMobile) {
            this.onBreakpointChange(newBreakpointMobile);
        }

        this.setSizes();
        this.scale = this.elWidth / this.resources.blob.texture.orig.width;

        this.bubbles.forEach(bubble => bubble.resize());

        if(this.blob) {
            this.blob.resize();
        }

        this.app.renderer.resize(this.elWidth, this.elHeight);
    }

    initEvents() {
        window.addEventListener('resize', debounce(this.onResize.bind(this), 100));
    }

    onResize() {
        const newWidth = window.innerWidth;
        if(newWidth === this.windowWidth) return;
        this.windowWidth = newWidth;
        this.resizeHandler();
    }

    onBreakpointChange(breakpointMobile) {
        this.currentBreakpointMobile = breakpointMobile;
        if(breakpointMobile) {
            this.app.ticker.stop();
        } else {
            this.app.ticker.start();
        }
    }
}

export default RaisingHealthScene;
